<template>
    <ul
        v-if="headerReleased"
        class="border rounded-lg overflow-hidden"
        :style="{
            'border-color': player.borderColor,
        }"
    >
        <SidebarHedaer @click="toggleSection" :isOpen="isOpen" :section="section" />
        <template v-if="isOpen">
            <SidebarFile v-for="file in releasedFiles" :key="file.id" :file="file" />
        </template>
    </ul>
</template>

<script>
import { mapState } from "vuex";
import SidebarFile from "./SidebarFile.vue";
import SidebarHedaer from "./SidebarHeader.vue";

export default {
    props: {
        section: Object,
    },
    data() {
        return {
            isOpen: true,
        };
    },
    computed: {
        ...mapState("shared/view", ["preview"]),
        ...mapState("player/view", ["player"]),
        notDeletedFiles() {
            return this.section.files.filter((file) => !file._deleted && !file.hide);
        },
        headerReleased() {
            if (this.preview) {
                return true;
            }
            const now = new Date();
            return !(
                this.section.header.releaseAt &&
                new Date(this.section.header.releaseAt) > now &&
                !this.section.header.showBeforeRelease
            );
        },
        releasedFiles() {
            if (this.preview) {
                return this.notDeletedFiles;
            }
            const now = new Date();
            return this.notDeletedFiles.filter(
                (file) =>
                    !(file.releaseAt && new Date(file.releaseAt) > now && !file.showBeforeRelease)
            );
        },
    },
    components: { SidebarFile, SidebarHedaer },
    methods: {
        toggleSection() {
            this.isOpen = !this.isOpen;
        },
    },
};
</script>
